import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IDetails_Response } from '@shared/constants/models.const';
import { E_CONTENT_TYPE, E_DATE_FORMAT, E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { TocComponent } from '@shared/components/toc/toc.component';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { RelatedItemsComponent } from '@shared/components/related-items/related-items.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { HelperService } from '../../services/helper.service';
import ical, { ICalCalendarMethod } from 'ical-generator';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';

@Component({
  selector: 'app-important-dates-detail',
  imports: [
    ThreeColumnTemplateComponent,
    SideNavigationComponent,
    TocComponent,
    CkViewerComponent,
    LinksSectionComponent,
    TranslateModule,
    RelatedItemsComponent,
    DefaultPortletsComponent,

  ],
  templateUrl: './important-dates-detail.component.html',
  styleUrl: './important-dates-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportantDatesDetailComponent {
  pageData = input<IDetails_Response | any>();
  E_FOLDER_TYPES = E_FOLDER_TYPES;
  E_CONTENT_TYPE = E_CONTENT_TYPE;
  protected readonly ButtonTypes = BUTTON_TYPES;

  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  constructor(
    public HELPER: HelperService,
  ) {}

  createICal() {
    const calendar = ical({ name: this.pageData().title });
    calendar.method(ICalCalendarMethod.REQUEST);

    const startTime = new Date(this.pageData().startDate);
    const endTime = new Date(this.pageData().endDate);

    const calendarObj = {
      start: startTime,
      end: endTime,
      summary: this.pageData().title,
      description: this.pageData().summary,
      location: this.pageData().location,
      url: '',
    };
    calendar.createEvent(calendarObj);
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(calendar.toString()));
    element.setAttribute('download', `event.ics`);
    element.setAttribute('target', '_blank');
    element.style.display = 'none';
    element.click();
  }

}
